import {
  Stack,
  Button,
  Radio,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import { Choice } from "../../../../apis/copilot/types";
import { useState } from "react";
import { ReasoningTooltip } from "../ReasoningTooltip";

interface Props {
  choices: Choice[];
  onInsert: (choice: Choice) => void;
  target: string;
}

export const SingleSelect: React.FC<Props> = ({
  choices,
  onInsert,
  target,
}) => {
  const [selectedItem, setSelectedItem] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleItemSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedItem(event.target.value);
  };

  return (
    <>
      <Stack direction="column" id="copilot-radio-container">
        <RadioGroup
          id="copilot-radio-group"
          value={selectedItem}
          onChange={handleItemSelectionChange}
        >
          {choices.map(({ id, name, reason }) => (
            <FormControlLabel
              key={id}
              value={id}
              control={<Radio id={`copilot-checkbox-${id}`} />}
              label={<ReasoningTooltip reason={reason} label={name} />}
              disabled={isDisabled}
            />
          ))}
        </RadioGroup>
      </Stack>

      <Button
        id="copilot-merge-button"
        variant="outlined"
        color="primary"
        disabled={!selectedItem || isDisabled}
        onClick={() => {
          setIsDisabled(true);
          onInsert(choices.find(({ id }) => id === selectedItem) as Choice);
        }}
      >
        {`merge${isDisabled ? "d" : ""} into ${target}`}
      </Button>
    </>
  );
};
